import * as React from "react";
import { useFormApi, useFormState } from "informedv4";

import { Dropdown } from "../../../../forms/informedv4/DropdownV4";
import { SubjectType } from "webportalclient";
import { useCurrentStudyConfigurationContext } from "../../../../Core/CurrentStudyConfigurationContext";

interface EnterNewSubjectTypeProps {
    originalSubjectType: string;
    onNext: (newSubjectType: string) => void;
    subjectTypes: SubjectType[];
}

interface EnterNewSubjectTypeForm {
    correctedSubjectType: string;
}

export const EnterNewSubjectType = ({ originalSubjectType, onNext, subjectTypes }: EnterNewSubjectTypeProps): JSX.Element => {    

    const { fieldDisplayText } = useCurrentStudyConfigurationContext();
    const formApi = useFormApi();
    const formState = useFormState();

    const onSubmit = () => {
        formApi.validate();

        const state = formApi.getFormState()
        if (state.invalid)
            return;

        onNext(state.values.correctedSubjectType as string);
    }

    const subjectTypeDisplayText = fieldDisplayText.SubjectType;

    return (
        <>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <p className="text-muted">
                            {`Correcting ${subjectTypeDisplayText}`}
                    </p>
                        <div className="form-group">
                            <label>{`Current ${subjectTypeDisplayText}`}</label>&nbsp;
                            <Dropdown
                                name="originalSubjectType"
                                disabled={true}
                                id={`select-subjectType-prevalue`}
                                field="originalSubjectType"
                                className="form-control"
                            >
                                {subjectTypes.map(s => (
                                    <option key={`SubjectTypePre${s.id}`} value={s.id}>
                                        {s.name}
                                    </option>
                                ))}
                            </Dropdown>
                        </div>
                        <div className="form-group">
                            <label>{`Select New ${subjectTypeDisplayText}`}</label>&nbsp;
                            <Dropdown
                                name="correctedSubjectType"
                                disabled={false}
                                id={`select-subjectType-correctedValue`}
                                field="correctedSubjectType"
                                className="form-control"
                            >
                                {subjectTypes.map(s => (
                                    <option key={`SubjectTypeCorr${s.id}`} value={s.id}>
                                        {s.name}
                                    </option>
                                ))}
                            </Dropdown>
                        </div>

                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button disabled={!formState.values.correctedSubjectType || formState.values.correctedSubjectType == originalSubjectType} className="btn btn-primary" type="submit" onClick={() => onSubmit()}>
                    Next
                </button>
            </div>
        </>);
};
